export const SET_AGENT_INFO = 'SET_AGENT_INFO';
